<template>
    <el-dialog
      title="Редактирование вопроса"
      :visible="visible"
      :before-close="close"
      :width="'80%'"
      @opened="onOpen"
    >

    <el-form ref="editForm" :rules="editFormRules" :model="editForm">
      <el-form-item label="Вопрос" prop="name">
        <el-input name="name" ref="autoFocus" placeholder="Введите название вопроса..." v-model="editForm.name"></el-input>
      </el-form-item>
      <el-form-item label="Тип вопроса" prop="type" v-if="editForm.type == 140">
        <el-select v-model="editForm.type" class="dialog__select">
          <el-option :value="20" label="Да/нет" />
          <el-option :value="40" label="Вопрос с уточнением" />
          <el-option :value="60" label="Текстовое поле" />
        </el-select>
      </el-form-item>
      <el-form-item label="Тип справочника" prop="compendium" v-if="editForm.type == 40">
        <el-select v-model="editForm.compendium" class="dialog__select">
          <el-option value="disease" label="Заболевания" />
          <el-option value="2" label="БАДы" />
        </el-select>
      </el-form-item>
    </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loadEditForm" @click="editQuestion">Сохранить и закрыть</el-button>
      </span>

  </el-dialog>
</template>

<script>
export default {
  name: 'QuestionEditModal',
  data () {
    return {
      form: null,
      error: null,
      loadEditForm: !!0,
      editForm: {
        type: '20'
      },
      editFormRules: {
        name: [
          { required: true, message: 'Укажите название', trigger: 'blur' }
        ],
        type: [{ required: true, message: 'Выберите тип', trigger: 'blur' }],
        compendium: [
          { required: true, message: 'Выберите тип', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {

  },
  props: {
    listId: {
      required: true
    },
    question: {
      required: true
    },
    visible: {
      required: true
    }
  },
  methods: {
    onOpen () {
      this.loadLogic()
    },
    close () {
      this.$emit('close')
    },
    loadLogic () {
      this.autoFocus()

      this.editForm = {
        type: this.question.type,
        name: this.question.schema.text,
        compendium: this.question.schema.compendium
      }
    },
    autoFocus () {
      this.$refs.autoFocus.focus()
    },
    editQuestion (close) {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loadEditForm = !!1

          const payLoad = {
            questionnaire_list_id: this.listId,
            type: this.editForm.type,
            schema: {
              text: this.editForm.name,
              compendium: this.editForm.compendium
            }
          }
          this.$api.question
            .edit(this.question.id, payLoad)
            .then(() => {
              this.$notify.success({
                title: 'Успешно',
                message: 'Вопрос сохранен'
              })
              if (close) {
                this.$emit('update')
                this.$emit('close')
              } else {
                this.$emit('update')
                this.editForm = {
                  type: '20'
                }
                this.autoFocus()
              }
            })
            .catch((response) => {
              this.$notify.error({
                title: 'Ошибка',
                message: response.response.data.message
              })
            })
            .finally(() => {
              this.loadEditForm = !!0
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.dialog {
  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #aaaeba;
    margin: 25px 0 40px 0;

    &_mini {
      font-size: 14px;
    }
  }

  &__select {
    margin: 10px 0;
    width: 100%;
  }
  &__btns {
    float: right;
  }
}

.modal-header {
  font-size: 24px;
  margin: 0;
  color: #5574a1;

  &__icon {
    float: right;
    cursor: pointer;
  }
}
.modal-footer {
  padding: 40px 0;

  &__button {
    float: right;
  }
}
</style>
